export default __webpack_public_path__ + "static/media/Distribution of Attacks Among Manufacturing.612cb703.PNG";